export default [
  {
    Category: "Watches",
    commissionType: "Fixed",
    commissionFee: "799"
  },
  {
    Category: "Bags",
    commissionType: "Percentage",
    commissionFee: "9"
  },
  
  
  {
    Category: "Caps",
    commissionType: "Percentage",
    commissionFee: "7"
  }
];
